(() => {
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-le-size-help-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.leSizeHelpOpen);
      if (dialog && !dialog.open) dialog.showModal();
      return;
    }
    const close = event.target.closest('[data-le-size-help-close]');
    if (close) close.closest('dialog').close();
    if (event.target.matches('dialog.le-size-dialog')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
  });
})();
